import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PageComponent } from '@app/page/page.component';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-list-your-property',
  standalone: true,
  imports: [
    RouterModule,
    AngularSvgIconModule,
    NgOptimizedImage,
    CommonModule,
    PageComponent
  ],
  templateUrl: './list-your-property.component.html',
  styleUrls: ['./list-your-property.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ListYourPropertyComponent {

  public desktop = new BehaviorSubject(true);

  private destroyed = new Subject<void>();

  constructor(private responsive: BreakpointObserver) {}

  ngOnInit() {
    this.responsive.observe([
      Breakpoints.XSmall,
      Breakpoints.Small,
      Breakpoints.Medium,
    ])
    .pipe(
      takeUntil(this.destroyed)
    )
    .subscribe(result => {
      if (result.matches) {
        this.desktop.next(false);
      } else {
        this.desktop.next(true);
      }
    });
  }

  ngOnDestroy() {
    this.destroyed.next();
    this.destroyed.complete();
  }
}
